import React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    required,
} from "react-admin";


export const GovernmentInstitutionList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" label="Название" />
            <TextField source="gov_code" label="Код ГУ" />
            <EditButton />
        </Datagrid>
    </List>
);


export const GovernmentInstitutionCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <TextInput source="gov_code" label="Код ГУ" validate={[required()]} />
        </SimpleForm>
    </Create>
);


export const GovernmentInstitutionEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" label="Название" validate={[required()]} />
            <TextInput source="gov_code" label="Код ГУ" validate={[required()]} />
        </SimpleForm>
    </Edit>
);